import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const ClosedHashingAndDynamicHashing = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Closed Hashing - Random Probing – Rehashing - Extendible Hashing"
    videos={[
      "https://www.youtube.com/embed/ti5fyHn3t44?si=O6OKOK6GUXveB2Vk",
      "https://www.youtube.com/embed/nRwfgHRJgqE?si=JdkIc1XsTtihUaLH"
    ]}
    takeaways={[]}
    questions={[]}
    exampleVideos={[]}
  />
);
}

export default ClosedHashingAndDynamicHashing;
